import React from "react"
import JobFunctionsCheckbox from "./jobFunctionsCheckbox"
import PositionSeniorityCheckbox from "./positionSeniorityCheckbox"
import {IoIosAddCircle, IoMdArrowDropdown, IoIosCloseCircle, IoMdArrowDropup} from "react-icons/io"
import AsyncSelect from "react-select/lib/Async";
import ApiService from "../../../Services/ApiService.js"
import JobFunctions from "./jobFunctions.js"
import AutocompleteBadge from "../../../components/autocompleteBadge.js"


class AudienceForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            campaign_id: props.data.campaign_id ?? 0,
            client_id: props.data.client_id ?? 0,
            job_functions: props.data.job_functions ?? [],
            seniorities: props.data.seniorities ?? [],
            locations: props.data.locations ?? [],
            job_titles: props.data.job_titles ?? [],
            job_skills: props.data.job_skills ?? [],
            newLocation: "",
            hide_job_functions: false,
            hide_positions: false,
            hide_locations: false,
            hide_job_titles: false,
            hide_job_skills: false,
            hide_locales: false,
            ranking: props.ranking ?? false,
            available_locales: [],
            locale_id: 4 // english
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (!this.arraysEqual(prevProps.data, this.props.data)) {
            this.setState({...this.state,
            campaign_id: this.props.data.campaign_id,
            client_id: this.props.data.client_id,
            job_functions: this.props.data.job_functions,
            job_titles: this.props.data.job_titles,
            job_skills: this.props.data.job_skills,
            seniorities: this.props.data.seniorities,
            locations: this.props.data.locations,
            ranking: this.props.ranking,
            locale_id: this.props.data.locale_id
        });
        }
    }


    componentDidMount() {
        this.setLocales();
    }

    arraysEqual = (a1, a2)  =>  {
        return JSON.stringify(a1) === JSON.stringify(a2);
    };

    showOrHideJobFunctions = () => {
        let currentState = this.state.hide_job_functions;
        this.setState({hide_job_functions: !currentState});
    };

    showOrHideSeniortyPositions = () => {
        let currentState = this.state.hide_positions;
        this.setState({hide_positions: !currentState});
    };

    showOrHideLocations = () => {
        let currentState = this.state.hide_locations;
        this.setState({hide_locations: !currentState});
    };

    showOrHideJobTitles = () => {
        let currentState = this.state.hide_job_titles;
        this.setState({hide_job_titles: !currentState});
    };

    showOrHideJobSkills = () => {
        let currentState = this.state.hide_job_skills;
        this.setState({hide_job_skills: !currentState});
    };

    showOrHideLocations = () => {
        let currentState = this.state.hide_locales;
        this.setState({hide_locales: !currentState});
    };

    handleJobFunctionChange(selectedJobFunctions) {
        this.setState({...this.state, job_functions: selectedJobFunctions});
        this.props.onFormChange('job_functions', selectedJobFunctions);
    };

    handleSeniorityChange(selectedSeniorities) {
        this.setState({...this.state, seniorities: selectedSeniorities});
        this.props.onFormChange('seniorities', selectedSeniorities);
    };

    handleLocaleChange(selectedLocale) {
        const localeID = selectedLocale.target.value;
        this.setState({...this.state, locale: localeID});
        this.props.onFormChange('locale_id', localeID);
    };

    fetchLocation = inputValue =>
        new Promise(resolve => {
            if (inputValue.length >= 2)
            {
                ApiService.get('/api/linkedin/search-locations?client_id=' + this.state.client_id + '&location=' + inputValue.toLowerCase()).then(response => {
                    let matches = [];
                    for (let i = 0; i < response.data.matches.length; i++) {
                        matches.push({
                            'value': response.data.matches[i].value,
                            'label': response.data.matches[i].name,
                            'id': response.data.matches[i].urn
                        });
                    }
                    resolve(matches);
                }).catch(() => resolve([]))
            }
        });

    fetchJobTitles = inputValue =>
        new Promise(resolve => {
            if (inputValue.length >= 2)
            {
                ApiService.get('/api/linkedin/job-titles?client_id=' + this.state.client_id + '&search=' + inputValue.toLowerCase())
                .then(response => {
                    let matches = [];
                    for (let i = 0; i < response.data.matches.length; i++) {
                        matches.push({
                            'value': response.data.matches[i].value,
                            'label': response.data.matches[i].name,
                            'id': response.data.matches[i].urn
                        });
                    }
                    resolve(matches);
                }).catch(() => resolve([]))
            }
        });

    fetchJobSkills = inputValue =>
        new Promise(resolve => {
            if (inputValue.length >= 2)
            {
                ApiService.get('/api/linkedin/job-skills?client_id=' + this.state.client_id + '&search=' + inputValue.toLowerCase())
                .then(response => {
                    let matches = [];
                    for (let i = 0; i < response.data.matches.length; i++) {
                        matches.push({
                            'value': response.data.matches[i].value,
                            'label': response.data.matches[i].name,
                            'id': response.data.matches[i].urn
                        });
                    }
                    resolve(matches);
                }).catch(() => resolve([]))
            }
        });

        setLocales = () => {
            const url = "/api/linkedin/locales";
    
            ApiService.get(url)
                .then(response => {
                    let locales = response.data;
                    this.setState({...this.state.data, available_locales: locales})
            
                });
    
        }      


    handleLocationSelection(selected) {
        this.props.onFormChange('locations', selected);
    }

    handleLocationRemoveSelection(remove) {

        let locations = this.state.locations;
        const index = locations.indexOf(remove.trim());

        if (index > -1) {
            locations.splice(index, 1);
        }

        this.props.onFormChange('locations', locations);

        this.setState({...this.state, locations: locations})
    }

    handleJobTitleSelection(selected) {
        this.props.onFormChange('job_titles', selected);
    }

    handleJobTitleRemoveSelection(remove) {

        let jobTitles = this.state.job_titles;
        const index = jobTitles.indexOf(remove.trim());

        if (index > -1) {
            jobTitles.splice(index, 1);
        }

        this.props.onFormChange('job_titles', jobTitles);

        this.setState({...this.state, job_titles: jobTitles})
    }

    handleJobSkillSelection(selected) {
        this.props.onFormChange('job_skills', selected);
    }

    handleJobSkillRemoveSelection(remove) {

        let jobSkills = this.state.job_skills;
        const index = jobSkills.indexOf(remove.trim());

        if (index > -1) {
            jobSkills.splice(index, 1);
        }

        this.props.onFormChange('job_skills', jobSkills);

        this.setState({...this.state, job_skills: jobSkills})
    }


    setSelectedCampaignJobFunctions(campaignId) {
        let url = '/api/campaigns/fetch-campaign-job-functions?campaign_id=' + campaignId;
        ApiService.get(url).then(response => {
            let campaignJobFunctions = response.data;
            let campaignJobFunctionIds = campaignJobFunctions.map((jobFunction) => {
                return jobFunction.ADZLinkedInJobFunctions_ID;
            });

            this.setState({...this.state, job_functions: campaignJobFunctionIds});

        })
    }

    render() {

        let isRanking = this.state.ranking;
        let $jobFunctionSection = null;
        let localeOptions = null;

        if (isRanking) {

            $jobFunctionSection = (
                <JobFunctions data={this.state.job_functions} onJobFunctionsChange={this.handleJobFunctionChange.bind(this)}/>
        )
        } else {

            $jobFunctionSection = (

                <JobFunctionsCheckbox data={this.state.job_functions} onJobFunctionsChange={this.handleJobFunctionChange.bind(this)}/>
        )
        }

        if (this.state.available_locales && this.state.available_locales.length > 0) {

            localeOptions = (
                <select name="locale_id" value={this.state.locale_id} onChange={this.handleLocaleChange.bind(this)}>
                    <option value={0}>(Select one)</option>
                     {this.state.available_locales.map((item, index) =>
                        <option key={"locale_" + item.ID} value={item.ID}>{item.Locale}</option>
                    )}
                </select>
            )
        }

        return(
            <div className="accounts-ads">

                <div id="location-section">
                    <div className="section">
                        <div onClick={this.showOrHideLocations} hidden={this.state.hide_locations}>
                            <IoMdArrowDropdown className="arrow-icon"/>
                        </div>
                        <div onClick={this.showOrHideLocations} hidden={!this.state.hide_locations}>
                            <IoMdArrowDropup className="arrow-icon"/>
                        </div>
                        <div className="title">
                            Locations
                        </div>
                    </div>
                    <div className="body" hidden={this.state.hide_locations}>

                        <div className="description">
                            Where is your target audience? (Valid locations are currently limited to countries and states only)
                        </div>

                        <AutocompleteBadge
                            searchFunction={this.fetchLocation}
                            onSelection={this.handleLocationSelection.bind(this)}
                            onRemoval={this.handleLocationRemoveSelection.bind(this)}
                            selected={this.props.data.locations}
                            title="location"
                        />
                    </div>


                </div>

                <div hidden={!isRanking}>
                <div className="section">
                        <div onClick={this.showOrHideLocales} hidden={this.state.hide_locales}>
                            <IoMdArrowDropdown className="arrow-icon"/>
                        </div>
                        <div onClick={this.showOrHideLocales} hidden={!this.state.hide_locales}>
                            <IoMdArrowDropup className="arrow-icon"/>
                        </div>
                        <div className="title">
                            Profile Language
                        </div>
                    </div>
                    <div className="body" hidden={this.state.hide_locales}> 
                        {localeOptions}
                    </div>
                </div>

                <div hidden={!isRanking}>
                    <div className="section">
                        <div onClick={this.showOrHideJobTitles} hidden={this.state.hide_job_titles}>
                            <IoMdArrowDropdown className="arrow-icon"/>
                        </div>
                        <div onClick={this.showOrHideJobTitles} hidden={!this.state.hide_job_titles}>
                            <IoMdArrowDropup className="arrow-icon"/>
                        </div>
                        <div className="title">
                            Job Titles
                        </div>
                    </div>

                    <div className="body" hidden={this.state.hide_job_titles}>

                        <AutocompleteBadge
                            searchFunction={this.fetchJobTitles}
                            onSelection={this.handleJobTitleSelection.bind(this)}
                            onRemoval={this.handleJobTitleRemoveSelection.bind(this)}
                            selected={this.props.data.job_titles}
                            title="jobTitle"
                        />
                    </div>
                </div>

                <div hidden={!isRanking}>
                    <div className="section">
                        <div onClick={this.showOrHideJobSkills} hidden={this.state.hide_job_skills}>
                            <IoMdArrowDropdown className="arrow-icon"/>
                        </div>
                        <div onClick={this.showOrHideJobSkills} hidden={!this.state.hide_job_skills}>
                            <IoMdArrowDropup className="arrow-icon"/>
                        </div>
                        <div className="title">
                            Member Skills
                        </div>
                    </div>

                    <div className="body" hidden={this.state.hide_job_skills}>

                        <AutocompleteBadge
                            searchFunction={this.fetchJobSkills}
                            onSelection={this.handleJobSkillSelection.bind(this)}
                            onRemoval={this.handleJobSkillRemoveSelection.bind(this)}
                            selected={this.props.data.job_skills}
                            title="jobSkill"
                        />
                    </div>
                </div>


                <div className="section">
                    <div onClick={this.showOrHideJobFunctions} hidden={this.state.hide_job_functions}>
                        <IoMdArrowDropdown className="arrow-icon"/>
                    </div>
                    <div onClick={this.showOrHideJobFunctions} hidden={!this.state.hide_job_functions}>
                        <IoMdArrowDropup className="arrow-icon"/>
                    </div>
                    <div className="title">
                        Job Function
                    </div>
                </div>
                <div className="body" hidden={this.state.hide_job_functions}>
                    <div className="description">
                        Select the Job Functions you wish to target. For the most effective campaigns, target at most 3 job functions.
                    </div>
                    {$jobFunctionSection}
                </div>
                <div className="section">
                    <div onClick={this.showOrHideSeniortyPositions} hidden={this.state.hide_positions}>
                        <IoMdArrowDropdown className="arrow-icon"/>
                    </div>
                    <div onClick={this.showOrHideSeniortyPositions} hidden={!this.state.hide_positions}>
                        <IoMdArrowDropup className="arrow-icon"/>
                    </div>
                    <div className="title">
                        Position Seniority
                    </div>
                </div>
                <div className="body" hidden={this.state.hide_positions}>
                    <div className="description">
                        Select the position seniority you wish to target. Consider the mix of decision makers and those influencers who may have more
                        time/bandwith to respond to online advertizing.
                    </div>
                    <PositionSeniorityCheckbox data={this.state.seniorities} onSenioritiesChange={this.handleSeniorityChange.bind(this)}/>
                </div>

            </div>

        )
    }
}



export default AudienceForm